import BigChart from './BigChart';

export default BigChart;
